// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bcj_a bhs_ke","ListItemIcon--empty":"bcj_b bhs_fl"};